import { render, staticRenderFns } from "./SteelKnight.vue?vue&type=template&id=02fbbd4b&scoped=true"
import script from "./SteelKnight.vue?vue&type=script&lang=js"
export * from "./SteelKnight.vue?vue&type=script&lang=js"
import style0 from "./SteelKnight.vue?vue&type=style&index=0&id=02fbbd4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fbbd4b",
  null
  
)

export default component.exports